export default __webpack_public_path__ + "static/media/LV.45e2581f.ico";